/*
 * Copyright (c) Schrocken Inc.
 * Author: Harish
 * File Description: Actions file for ecosystem creation
 */

/* eslint-disable no-console */
import axios from 'axios';

import { smlUrl } from '../../utils/config';

import {
  GET_MOSYMPHONY_SETTINGS,
  UPDATE_MOSYMPHONY_SETTINGS,
  RESET_MOSYMPHONY_SETTINGS,
  ADD_ORGANIZATION,
  GET_ORGANIZATION,
  COLLABORATOR_TYPE,
  COLLABORATOR_ROLE,
  ECOSYSTEM_TYPE,
  SEND_BRAND_OWNER_INVITATION,
  GET_ECOSYSTEMS,
} from './types';

export const getMosymphonySettings = () => (dispatch) => {
  axios
    .get(`${smlUrl}/admin/fetchSchrockenMosymphonySettings`)
    .then((res) => {
      dispatch({
        type: GET_MOSYMPHONY_SETTINGS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const updateMosymphonySettings = (data) => (dispatch) => {
  axios
    .put(`${smlUrl}/admin/updateSchrockenMosymphonySettings`, data)
    .then((res) => {
      dispatch({
        type: UPDATE_MOSYMPHONY_SETTINGS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 400) {
        dispatch({
          type: UPDATE_MOSYMPHONY_SETTINGS,
          payload: err.response.data,
        });
      }
      console.log(err);
    });
};

export const resetToDefault = () => (dispatch) => {
  axios
    .post(`${smlUrl}/admin/resetDefaultSettings`)
    .then((res) => {
      axios
        .get(`${smlUrl}/admin/fetchSchrockenMosymphonySettings`)
        .then((res) => {
          dispatch({
            type: GET_MOSYMPHONY_SETTINGS,
            payload: res.data,
          });
        })
        .catch((err) => {
          console.log(err);
        });
      dispatch({
        type: RESET_MOSYMPHONY_SETTINGS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const addOrganization = (organizationData) => (dispatch) => {
  axios
    .post(`${smlUrl}/admin/organizationDetails`, organizationData)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: ADD_ORGANIZATION,
          payload: res.data,
        });
        axios
          .get(`${smlUrl}/admin/organizationDetails`)
          .then((res) => {
            dispatch({
              type: GET_ORGANIZATION,
              payload: res.data,
            });
            // console.log("action data",res.data)
          })
          .catch((err) => {
            console.log('error data', err);
          });
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: ADD_ORGANIZATION,
        payload: err.response.data,
      });
    });
};

export const getOrganization = () => (dispatch) => {
  axios
    .get(`${smlUrl}/admin/organizationDetails`)
    .then((res) => {
      dispatch({
        type: GET_ORGANIZATION,
        payload: res.data,
      });
      // console.log("action data",res.data)
    })
    .catch((err) => {
      console.log('error data', err);
    });
};

export const getCollaboratorType = () => (dispatch) => {
  axios
    .get(`${smlUrl}/admin/collaboratorType`)
    .then((res) => {
      dispatch({
        type: COLLABORATOR_TYPE,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log('error data', err);
    });
};

export const getCollaboratorRole = (data) => (dispatch) => {
  axios
    .post(`${smlUrl}/admin/collaboratorRoles`, data)
    .then((res) => {
      dispatch({
        type: COLLABORATOR_ROLE,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log('error data', err);
    });
};

// get collabs in a particular ecosystem
export const getEcosystemCollaborators = () => (dispatch) => {
  axios
    .get(`${smlUrl}/user/getEcosytemCollaborators`)
    .then((res) => {
      dispatch({
        type: COLLABORATOR_TYPE,
        payload: res.data,
      });
    })
    .catch((err) => console.log(err));
};
export const ecosystemType = () => (dispatch) => {
  axios
    .get(`${smlUrl}/admin/ecosystemType`)
    .then((res) => {
      dispatch({
        type: ECOSYSTEM_TYPE,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log('error data', err);
    });
};

export const getEcosystems = () => (dispatch) => {
  axios
    .get(`${smlUrl}/admin/fetchEcosystems`)
    .then((res) => {
      dispatch({
        type: GET_ECOSYSTEMS,
        payload: res.data,
      });
    })
    .catch((err) => console.log(err));
};

export const sendBrandOwner = (data) => (dispatch) => {
  axios
    .post(`${smlUrl}/admin/sendBrandOwnerInvitation`, data)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: SEND_BRAND_OWNER_INVITATION,
          payload: res.data,
        });
        axios
          .get(`${smlUrl}/admin/fetchEcosystems`)
          .then((response) => {
            if (response.data.status === true) {
              dispatch({
                type: GET_ECOSYSTEMS,
                payload: response.data,
              });
            }
          })
          .catch((err) => console.log(err));
      }
    })
    .catch((err) => {
      if (err.response.status === 400) {
        dispatch({
          type: SEND_BRAND_OWNER_INVITATION,
          payload: err.response.data,
        });
      }
    });
};
